import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { SearchkitClient, SearchkitProvider } from '@searchkit/client'
import { ThemeProvider } from '@mui/material'
import React from 'react'

import ApolloProvider from 'core/ApolloProvider'
import defaultTheme from 'config/theme'
import history from 'store/history'
import MapProvider from 'core/Map/MapProvider'
import Router from 'core/Router'
import store from 'store/configureStore'

const App = () => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(defaultTheme)
  }

  const skClient = new SearchkitClient()

  return (
    <Provider store={store}>
      <ThemeProvider theme={defaultTheme}>
        <ConnectedRouter history={history} noInitialPop>
          <ApolloProvider>
            <SearchkitProvider client={skClient}>
              <MapProvider>
                <Router />
              </MapProvider>
            </SearchkitProvider>
          </ApolloProvider>
        </ConnectedRouter>
      </ThemeProvider>
    </Provider>
  )
}

export default App
